import { CostCollectoryMultipyModelsAttributes } from "./CostCollectoryMultipyModelsAttributes"

export const CostCollectAttributes = () => {
    return <CostCollectoryMultipyModelsAttributes />
}
